import { useContext } from "react";
import styles from "../../index.module.scss";
import LoaderImg from "../../../../assets/images/Loader.gif";
import { networkContext } from "../../../../contexts/NetworkContext/NetworkContextProvider";
import { NameAvatar } from "../../../nameImage";


export const UserListContainer = ({
  userList,
  setChatUser,
  userListLoad,
  onlineUsers,
  handleClick,
  notificationData,
  notificationUser,
}) => {
  const { handleShowMore, showMoreBtnStatus } = useContext(networkContext);
  return (
    <div className={styles.userListBox}>
      <div className={styles.userListBox__title}>
        <h2>All Participants</h2>
      </div>
      {userListLoad ? (
        <>
          <div className={styles.User_loader}>
            <img src={LoaderImg} alt="loader" />
          </div>
        </>
      ) : (
        <div className={styles.userListBox__userList}>
          {userList.length > 0 &&
            userList.map((user, index) => {
              return (
                <div
                  className={styles.userListBox__userList__user}
                  key={index}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleClick(user)}
                >
                  <div className={styles.userListBox__userList__user_container}>
                    <div
                      className={`${styles.ChatConnections__user__img} ${
                        onlineUsers.includes(user.id)
                          ? styles.ChatConnections__user__img_online
                          : ""
                      }`}
                    >
                      {user.photoUrl ? (
                        <img src={user.photoUrl} alt="user" />
                      ) : (
                        <NameAvatar
                          width={"3.125rem"}
                          height={"3.125rem"}
                          firstName={user.firstName}
                          lastName={user.lastName}
                          size={"1rem"}
                        />
                      )}
                      <span></span>
                    </div>
                    <div className={styles.ChatConnections__user__name}>
                      <h3>{`${user.firstName} ${user.lastName}`}</h3>
                    </div>
                  </div>

                  {notificationUser.includes(user.id) ? (
                    <div
                      className={
                        styles.userListBox__userList_user_Connect_container
                      }
                    >
                      {notificationData &&
                        notificationUser &&
                        notificationData[user.id]?.count && (
                          <button>{notificationData[user.id]?.count}</button>
                        )}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              );
            })}
          {!showMoreBtnStatus && (
            <div onClick={handleShowMore} className={styles.show_more_button}>
              Show More
            </div>
          )}
        </div>
      )}
    </div>
  );
};
